import styled from "styled-components";

const AppWrapper = styled.div`
  .alert {
    position: fixed;
    bottom: 3rem;
    right: 3rem;
  }
  .navbar {
    .nav-link {
      .btn-secondary {
        padding: 0;
        background: none;
        border: none;
      }
    }
  }
`;

export default AppWrapper;
